import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.array.find-index";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import { isNumericValue } from '../../../utils/vuex';
import get from 'lodash/get';
import set from 'lodash/set';
import pullAt from 'lodash/pullAt';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import isArray from 'lodash/isArray';
import uuidv4 from 'uuid/v4';
var regexImageExt = '(jp(e?)g|png|gif)';
var regexAudioExt = '(o(pus|g([gax]{1}))|spx|webm|mp3|(fl|a)ac|wav(e?))';
export default {
  name: 'ViewISWarnappAdmin',
  data: function data() {
    return {
      treeLoading: false,
      selected: null,
      originalTwin: null,
      twinDataStates: [],
      originalTwinDataStates: [],
      search: null,
      // the "v-model"-bind for the state-selection
      // reset to empty array on each intersection, as we do not want to save any of it
      // just a quick workaround to make sure the form is always "clean"
      pickedKeys: {},
      selectStatePrompt: false,
      selectedState: null,
      selectedStateKey: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    attachmentButtons: function attachmentButtons() {
      return [{
        title: this.$i18n_t('DigitalTwin.DigitalTwin.attachmentButtonAdd'),
        icon: 'fal fa-plus',
        action: 'addAttachment'
      }];
    },
    uploadAccept: function uploadAccept() {
      var acceptedTypes = [];

      if (this.warnAppAttachments.findIndex(function (a) {
        return new RegExp("^warnapp_logo\\.".concat(regexImageExt, "$"), 'i').test(a.name);
      }) < 0) {
        acceptedTypes.push('image/*');
      }

      if (this.warnAppAttachments.findIndex(function (a) {
        return new RegExp("^warnapp_alarm\\.".concat(regexAudioExt, "$"), 'i').test(a.name);
      }) < 0) {
        acceptedTypes.push('audio/*');
      }

      return acceptedTypes.join(', ');
    },
    warnAppValidGauge: function warnAppValidGauge() {
      return (this.twinDataStates || []).find(function (state) {
        return state.key.toLowerCase() === 'warnapp_gauge';
      });
    },
    warnAppValidUpperLimit: function warnAppValidUpperLimit() {
      return (this.twinDataStates || []).find(function (state) {
        return state.key.toLowerCase() === 'warnapp_alarm_high';
      });
    },
    warnAppValidLowerLimit: function warnAppValidLowerLimit() {
      return (this.twinDataStates || []).find(function (state) {
        return state.key.toLowerCase() === 'warnapp_alarm_low';
      });
    },
    warnAppStates: function warnAppStates() {
      var _this = this;

      return (this.twinDataStates || []).filter(function (state) {
        return state.key !== get(_this.warnAppValidGauge, 'key') && state.key !== get(_this.warnAppValidUpperLimit, 'key') && state.key !== get(_this.warnAppValidLowerLimit, 'key') && get(state, 'properties.valueType') === 'number';
      });
    },
    warnStateChanged: function warnStateChanged() {
      if (get(this.warnAppValidUpperLimit, 'value.value') !== undefined) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.warnAppValidUpperLimit.value.value = parseFloat(this.warnAppValidUpperLimit.value.value);
      }

      if (get(this.warnAppValidLowerLimit, 'value.value') !== undefined) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.warnAppValidLowerLimit.value.value = parseFloat(this.warnAppValidLowerLimit.value.value);
      }

      return !isEqual(this.twinDataStates, this.originalTwinDataStates) || !isEqual(this.selected, this.originalTwin);
    },
    warnAppAttachments: function warnAppAttachments() {
      return get(this.selected, 'data.attachments', []).filter(function (a) {
        return new RegExp("^warnapp_logo\\.".concat(regexImageExt, "$"), 'i').test(a.name) || new RegExp("^warnapp_alarm\\.".concat(regexAudioExt, "$"), 'i').test(a.name);
      });
    }
  }),
  methods: {
    get: get,
    customFileSelectionHandler: function customFileSelectionHandler(files) {
      var regExpHasImageExt = new RegExp("\\.".concat(regexImageExt, "$"), 'i');
      var regExpHasAudioExt = new RegExp("\\.".concat(regexAudioExt, "$"), 'i');
      var mappedFiles = cloneDeep(files.filter(function (file) {
        return regExpHasImageExt.test(file.name) || regExpHasAudioExt.test(file.name);
      })); // only keep the first image or audio in the list, throw away the rest

      for (var i = 0; i < mappedFiles.length - 1; i++) {
        var currentFile = mappedFiles[i];

        for (var j = i + 1; j < mappedFiles.length; j++) {
          if (j !== i) {
            var followFile = mappedFiles[j];

            if (regExpHasImageExt.test(currentFile.name) && regExpHasImageExt.test(followFile.name)) {
              pullAt(mappedFiles, [j]);
              j--;
            } else if (regExpHasAudioExt.test(currentFile.name) && regExpHasAudioExt.test(followFile.name)) {
              pullAt(mappedFiles, [j]);
              j--;
            }
          }
        }
      }

      this.$refs.fileAttachments.queue = mappedFiles.map(function (file) {
        var newName = file.name;

        if (regExpHasImageExt.test(file.name)) {
          var rawFileName = new RegExp("^(.+?)\\.".concat(regexImageExt, "$"), 'i').exec(file.name);
          newName = "warnapp_logo.".concat(rawFileName[2].toLowerCase());
        } else if (regExpHasAudioExt.test(file.name)) {
          var _rawFileName = new RegExp("^(.+?)\\.".concat(regexAudioExt, "$"), 'i').exec(file.name);

          newName = "warnapp_alarm.".concat(_rawFileName[2].toLowerCase());
        }

        return new File([file], newName, {
          type: file.type,
          lastModified: file.lastModified
        });
      });
      this.$refs.fileAttachments.addFilesToUploads();
    },
    attachmentsUpdated: function attachmentsUpdated(data) {
      var _this2 = this;

      this.selected.data.attachments = data;
      this.$store.state.app.loading = true;
      return ApiService.digitalTwinUpdate(this, this.selected).then(function (result) {
        _this2.selected = result;

        _this2.$snack(_this2.$i18n_t('Common.digitalTwins.twinUpdated'), 'success');

        _this2.$store.state.app.dtwins = {};
        return _this2.selected;
      }).catch(function (error) {
        console.error(error);

        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('Common.digitalTwins.twinUpdatedFail'), 'error');
        }
      }).finally(function () {
        _this2.$store.state.app.loading = false;
      });
    },
    warnAppTypePicked: function warnAppTypePicked(state, type) {
      this.selectedState = state;
      this.selectedStateKey = type;
      this.selectStatePrompt = true;
    },
    createAlarmState: function createAlarmState(type) {
      var stateObject = {
        dtwinId: this.selected.id,
        key: "warnapp_alarm_".concat(type),
        value: {
          value: type === 'low' ? 0 : 100
        },
        properties: {
          title: "Warnapp Alarm ".concat(type.charAt(0).toUpperCase() + type.slice(1)),
          valueType: 'number',
          binding: {
            type: 'none'
          },
          visual: {
            type: 'hidden',
            options: {}
          }
        }
      };
      this.twinDataStates.push(stateObject);
    },
    statePickConfirmed: function statePickConfirmed() {
      if (this.selectedStateKey === 'warnapp_gauge') {
        // add a tag to identify this twin as having a valid warnapp state
        // (for the viewer tree selection)
        // make sure the tags are actually an array
        if (!isArray(get(this.selected, 'data.tags'))) {
          this.selected.data.tags = [];
        }

        var newTags = this.selected.data.tags.filter(function (t) {
          return t.toLowerCase() !== 'warnapp-sensor';
        }).concat(['warnapp-sensor']);
        this.selected.data.tags = newTags;

        if (!get(this.selectedState, 'properties.visual.options')) {
          set(this.selectedState, 'properties.visual.options', {});
        } // to display any gauge visualisation, make sure there is a non-null value


        if (!isNumericValue(this.selectedState.value.value)) {
          this.selectedState.value.value = 0;
          this.selectedState.value.hasChanged = true;
        }

        if (this.selectedState.properties.visual.type !== 'gauge') {
          this.selectedState.properties.visual.type = 'gauge';
          this.selectedState.properties.visual.options.min = '250';
          this.selectedState.properties.visual.options.max = '750';
          this.selectedState.properties.visual.options.thresholds = '250, 500';
          this.selectedState.properties.visual.options.reverse = false; // darkgreen, yellow, red

          this.selectedState.properties.visual.options.thresColors = ['#388e3c', '#fec60a', '#ff1744'];
        }
      }

      this.selectedState.key = this.selectedStateKey;
    },
    warnAppTypesForState: function warnAppTypesForState() {
      var types = [];

      if (!this.warnAppValidGauge) {
        types.push({
          text: 'WARN STATE',
          value: 'warnapp_gauge'
        });
      }

      if (!this.warnAppValidUpperLimit) {
        types.push({
          text: 'ALARM HIGH',
          value: 'warnapp_alarm_high'
        });
      }

      if (!this.warnAppValidLowerLimit) {
        types.push({
          text: 'ALARM LOW',
          value: 'warnapp_alarm_low'
        });
      }

      return types;
    },
    loadedInitialDtwins: function loadedInitialDtwins(dtwins) {
      if (dtwins && dtwins.length > 0) {
        this.selected = this.selected || dtwins[0];
        this.loadDigitalTwinStates(this.selected.id);
      }
    },
    loadDigitalTwinStates: function loadDigitalTwinStates(dtwinId) {
      var _this3 = this;

      this.originalTwin = cloneDeep(this.selected);
      this.twinDataStates = [];
      return ApiService.digitalTwinFetchStates(this, dtwinId).then(function (twinDataStates) {
        _this3.twinDataStates = twinDataStates;
        _this3.originalTwinDataStates = cloneDeep(_this3.twinDataStates);
      });
    },
    resetGaugeState: function resetGaugeState() {
      var _this4 = this;

      this.twinDataStates.forEach(function (state) {
        if (_this4.warnAppValidGauge && _this4.warnAppValidGauge.id === state.id) {
          state.key = "".concat(state.key, "_").concat(uuidv4());
        }
      }); // also remove the warnapp-sensor tag

      if (!isArray(get(this.selected, 'data.tags'))) {
        this.selected.data.tags = [];
      }

      var newTags = this.selected.data.tags.filter(function (t) {
        return t.toLowerCase() !== 'warnapp-sensor';
      });
      this.selected.data.tags = newTags;
    },
    saveStates: function saveStates() {
      var _this5 = this;

      var promises = [ApiService.digitalTwinUpdate(this, this.selected)];

      if (this.warnAppValidGauge) {
        promises.push(ApiService.digitalTwinUpdateState(this, this.warnAppValidGauge));
      }

      if (this.warnAppValidUpperLimit) {
        if (get(this.warnAppValidUpperLimit, 'value.value') !== get(this.originalTwinDataStates.find(function (s) {
          return s.key === _this5.warnAppValidUpperLimit.key;
        }), 'value.value')) {
          this.warnAppValidUpperLimit.value.hasChanged = true;
          this.warnAppValidUpperLimit.value.skipTransformer = true;
        }

        if (this.warnAppValidUpperLimit.id) {
          promises.push(ApiService.digitalTwinUpdateState(this, this.warnAppValidUpperLimit));
        } else {
          promises.push(ApiService.digitalTwinCreateState(this, this.warnAppValidUpperLimit).then(function (state) {
            _this5.warnAppValidUpperLimit.id = state.id;
          }));
        }
      }

      if (this.warnAppValidLowerLimit) {
        if (get(this.warnAppValidLowerLimit, 'value.value') !== get(this.originalTwinDataStates.find(function (s) {
          return s.key === _this5.warnAppValidLowerLimit.key;
        }), 'value.value')) {
          this.warnAppValidLowerLimit.value.hasChanged = true;
          this.warnAppValidLowerLimit.value.skipTransformer = true;
        }

        if (this.warnAppValidLowerLimit.id) {
          promises.push(ApiService.digitalTwinUpdateState(this, this.warnAppValidLowerLimit));
        } else {
          promises.push(ApiService.digitalTwinCreateState(this, this.warnAppValidLowerLimit).then(function (state) {
            _this5.warnAppValidLowerLimit.id = state.id;
          }));
        }
      }

      this.$store.state.app.loading = true;
      Promise.all(promises).then(function () {
        _this5.$snack(_this5.$i18n_t('Common.digitalTwins.twinUpdated'), 'success');

        _this5.$store.state.app.dtwins = {};
        _this5.originalTwinDataStates = cloneDeep(_this5.twinDataStates);
        _this5.originalTwin = cloneDeep(_this5.selected);
        return _this5.selected;
      }).catch(function (error) {
        console.error(error);

        if (error.response && _this5.$i18n_t("Error.".concat(error.response.data.message))) {
          _this5.$snack(_this5.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this5.$snack(_this5.$i18n_t('Common.digitalTwins.twinUpdatedFail'), 'error');
        }
      }).finally(function () {
        _this5.$store.state.app.loading = false;
      });
    }
  }
};